export default __webpack_public_path__ + "static/media/pin.44546f26.png";